import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { ACTION_ASSET_TYPES } from '../../constants/actionAssetTypes';
import { useHasRealmActionAccess } from './useHasRealmActionAccess';
import { jsx as _jsx } from "react/jsx-runtime";
const CreateAssetTemplateButton = ({
  assetId,
  assetType
}) => {
  const hasAccess = useHasRealmActionAccess();
  if (!hasAccess) {
    return null;
  }
  const portalId = PortalIdParser.get();
  const pluralAssetType = assetType === ACTION_ASSET_TYPES.REPORT ? 'reports' : 'dashboards';
  return /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: `/reporting-asset-library-manager/${portalId}/${pluralAssetType}/create/metadata/${assetId}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reporting-action-components.actions.createTemplate.${assetType}`
    })
  });
};
export default CreateAssetTemplateButton;